

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IndicateurModel } from '../models/IndicateurModel';
import { AnneeCanAddModel } from '../models/AnneeCanAddModel';
import { AnneesSelectedModel } from '../models/AnneesSelectedModel';
import { IdNomModel } from '../models/IdNomModel';
import { AideModel } from '../models/AideModel';
import { StringViewModel } from '../models/StringViewModel';

@Injectable({
   providedIn: 'root'
})
export class CommonApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/Common/getIndicateurs
    getIndicateurs(): Observable<IndicateurModel[]> {
        var _Url = `api/Common/getIndicateurs`;
            return this._httpClient.get<IndicateurModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAnnees
    getAnnees(): Observable<number[]> {
        var _Url = `api/Common/getAnnees`;
            return this._httpClient.get<number[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAnneesCanAdd?indicateurId=${indicateurId}
    getAnneesCanAdd(indicateurId: number): Observable<AnneeCanAddModel[]> {
        var _Url = `api/Common/getAnneesCanAdd?indicateurId=${indicateurId}`;
            return this._httpClient.get<AnneeCanAddModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAnneesForTransmissionRealise
    getAnneesForTransmissionRealise(): Observable<AnneesSelectedModel> {
        var _Url = `api/Common/getAnneesForTransmissionRealise`;
            return this._httpClient.get<AnneesSelectedModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAnneesForTableauFormation
    getAnneesForTableauFormation(): Observable<AnneesSelectedModel> {
        var _Url = `api/Common/getAnneesForTableauFormation`;
            return this._httpClient.get<AnneesSelectedModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAnneesPlus10
    getAnneesPlus10(): Observable<AnneesSelectedModel> {
        var _Url = `api/Common/getAnneesPlus10`;
            return this._httpClient.get<AnneesSelectedModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAnneesForTransmissionPrevisionnel
    getAnneesForTransmissionPrevisionnel(): Observable<AnneesSelectedModel> {
        var _Url = `api/Common/getAnneesForTransmissionPrevisionnel`;
            return this._httpClient.get<AnneesSelectedModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getTypeEtablissements
    getTypeEtablissements(): Observable<IdNomModel[]> {
        var _Url = `api/Common/getTypeEtablissements`;
            return this._httpClient.get<IdNomModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/clearCache
    clearCache(): Observable<boolean> {
        var _Url = `api/Common/clearCache`;
            return this._httpClient.get<boolean>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAide?code=${encodeURIComponent(code)}
    getAide(code: string): Observable<AideModel> {
        var _Url = `api/Common/getAide?code=${encodeURIComponent(code)}`;
            return this._httpClient.get<AideModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/getAides
    getAides(): Observable<AideModel[]> {
        var _Url = `api/Common/getAides`;
            return this._httpClient.get<AideModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Common/saveAide
    saveAide(aide: AideModel): Observable<boolean> {
        var _Url = `api/Common/saveAide`;
            return this._httpClient.post<boolean>(_Url, aide).pipe(catchError(this.handleError));
    }
    
    // post: api/Common/logClientError
    logClientError(message: StringViewModel): Observable<boolean> {
        var _Url = `api/Common/logClientError`;
            return this._httpClient.post<boolean>(_Url, message).pipe(catchError(this.handleError));
    }
    
    // get: api/Common/copyMediasToDatabase
    copyMediasToDatabase(): Observable<boolean> {
        var _Url = `api/Common/copyMediasToDatabase`;
            return this._httpClient.get<boolean>(_Url).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
